import { HTTP } from '../http';

export default {
  namespaced: true,

  state: {
    loading: false,
    gallery: null,
    wedding: null,
    galla: null,
    bar: null,
  },

  mutations: {
    set(state, gallery) {
      state.gallery = gallery;
    },
    wedding(state, wedding) {
      state.wedding = wedding;
    },
    galla(state, galla) {
      state.galla = galla;
    },
    bar(state, bar) {
      state.bar = bar;
    },
  },

  actions: {
    load({ commit }) {
      return HTTP.get('/gallery')
        .then((resp) => commit('set', resp.data))
        .catch((err) => commit('error/set', err.response, { root: true }));
    },
    wedding({ commit }) {
      return HTTP.get('/gallery/wedding/photos')
        .then((resp) => commit('wedding', resp.data))
        .catch((err) => commit('error/set', err.response, { root: true }));
    },
    galla({ commit }) {
      return HTTP.get('/gallery/galla/photos')
        .then((resp) => commit('galla', resp.data))
        .catch((err) => commit('error/set', err.response, { root: true }));
    },
    bar({ commit }) {
      return HTTP.get('/gallery/bar/photos')
        .then((resp) => commit('bar', resp.data))
        .catch((err) => commit('error/set', err.response, { root: true }));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/gallery.js